import modelExtraData from "models/backoffice/modelExtraData";

export default modelExtraData;
